export default __webpack_public_path__ + "static/media/phone-call.8e605019.png";